import * as React from "react";
import {Headings} from "../../elements/Headings/Headings";
import Video from "../../elements/Video/Video";
import {Paragraph} from "../../elements/Paragraph/Paragraph";
import {Button} from "../../elements/Button/Button";

import './VideoContainer.scss'

export const VideoContainer = ({ containerTitle, settings, videos }) => {
    return (
        <div className={'video-section'}>
            <Headings text={containerTitle} type={'h2'}/>
            {settings.subtext && <Paragraph text={settings.subtext}/>}

            <div className={'video-container-button'}>
                {settings.button_text && <Button label={settings.button_text} type={'button-secondary'} onClick={undefined}/>}
            </div>

            <div className={'video-grid'}>

                {videos.map((video, video_id) => (
                    <div key={video_id} className={`video-container ${video.settings.title.length > 0 ? 'with-details' : ''}`}>
                        <Video key={video_id} videoUrl={video.settings.src.sources[2].url}/>

                        <div className={`video-content`}>
                            <div className={'video-title'}>
                                <Headings text={video.settings.title} type={'h3'}/>
                            </div>

                            <div className={'video-tags'}>
                                <Paragraph text={video.settings.tags}/>
                            </div>

                            <div className={'video-description'}>
                                <Paragraph text={video.settings.description}/>
                            </div>

                            <span className={'video-date-read-time'}>
                                <Paragraph text={video.settings.date}/>
                                <Paragraph text={video.settings.read_time}/>
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default VideoContainer;